// Goodreads title, author, English paperback ISBN and review controls verified 24 October 2026.
// Keep Amazon null until the actual matching retail/review destination is live and checked.
// A Goodreads ASIN field containing an ISBN is not evidence of an Amazon listing.
export const reviewLinks = {
  goodreads: 'https://www.goodreads.com/book/show/262263269-we-burned-quietly#ReviewsSection',
  amazon: null,
};
